import type { MessageCountWhereInput } from '@/graphql/graphql';

export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';
export const IS_PRODUCTION = process.env.NODE_ENV === 'production';

export const DEFAULT_LOCALE: Locale = 'nl';

export const DEFAULT_MESSAGES_FILTER: MessageCountWhereInput = {
  AND: [{ OR: [{ type: null }, { type: { not: { equals: 'AUTOMATED' } } }] }],
};

export const DEBOUNCE_QUERY_TIME = 350;
